export default {"src":"/_next/static/media/national-forest-foundation.49772465.svg","height":79,"width":237};